<template>
  <div class="w-full pt-8 px-8 flex flex-col justify-center">
    <h3 class="text-cw-900 font-montserrat mb-2 text-center">
      Request a post pack
    </h3>
    <div class="flex items-start justify-between w-full mb-12">
      <h5 class="text-cw-300 text-center">
        If you would like to buy more posts, just fill out this form and the
        team will get back to you asap.
      </h5>
    </div>
    <div
      :style="{ maxWidth: '350px' }"
      class="flex flex-col justify-center items-center m-auto"
    >
      <div class="flex items-center space-x-4">
        <div
          class="rounded-full flex items-center justify-center border-2 w-14 h-14 relative flex-shrink-0 contributor-badge-cw"
        >
          <div
            v-if="organisation?.logo"
            class="bg-no-repeat bg-cover bg-center w-12 h-12 rounded-full"
            :style="{ backgroundImage: 'url(' + organisation.logo + ')' }"
          ></div>
          <div
            v-else
            class="flex justify-center items-center w-8 h-8 rounded-full text-cw-900"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-8 w-8"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fill-rule="evenodd"
                d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-6-3a2 2 0 11-4 0 2 2 0 014 0zm-2 4a5 5 0 00-4.546 2.916A5.986 5.986 0 0010 16a5.986 5.986 0 004.546-2.084A5 5 0 0010 11z"
                clip-rule="evenodd"
              />
            </svg>
          </div>

          <div
            :style="[{ top: '-0.5rem' }, { left: '2.3rem' }]"
            class="absolute border-2 border-white cw-gradient h-5 w-5 p-1 rounded-full text-white"
          >
            <div class="relative">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-2 w-2"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fill-rule="evenodd"
                  d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                  clip-rule="evenodd"
                />
              </svg>
            </div>
          </div>
        </div>

        <div class="flex flex-col justify-center">
          <h3
            v-if="organisation?.profile_title"
            class="text-cw-900 text-xl font-nunito m-0 font-bold"
          >
            {{ organisation.profile_title }}
          </h3>
        </div>
      </div>
      <h5 class="mt-6 mb-1 text-truegray-500 text-xs">
        Pack Size ( $99 + GST per post ):
      </h5>
      <div class="rounded relative bg-white border border-truegray-300 w-full">
        <input
          id="packSize"
          v-model="packSize"
          class="flex-grow px-4 mr-0 mt-1 outline-none focus:outline-none bg-transparent w-full h-12 text-black focus:placeholder-truegray-300"
          type="number"
          name="packSize"
          min="1"
        />
      </div>

      <h5 class="mt-4 mb-1 text-truegray-500 text-xs">Invoice Email:</h5>
      <div class="rounded relative bg-white border border-truegray-300 w-full">
        <input
          id="email"
          v-model="invoiceEmail"
          class="flex-grow px-4 mr-0 mt-1 outline-none focus:outline-none bg-transparent w-full h-12 text-black focus:placeholder-truegray-300"
          type="email"
          name="email"
          autocomplete="email"
        />
      </div>

      <button
        :disabled="!canSubmit || thinking"
        :class="[{ 'opacity-25 cursor-not-allowed': !canSubmit, thinking }]"
        class="btn btn-cw-cd-primary relative w-40 m-0 mt-8"
        @click="submit"
      >
        <div class="flex justify-center items-center w-full h-full">
          <div
            class="absolute inset-0 w-full flex justify-center items-center z-20"
          >
            <lottie v-if="thinking" :options="loadingAnimationOptions" />
          </div>
          <div
            :class="{ invisible: thinking }"
            class="w-full flex items-center justify-center"
          >
            Request
          </div>
        </div>
      </button>
    </div>
  </div>
</template>

<script>
import { defineComponent, computed, ref, onMounted } from 'vue'
import { useStore } from '../../../js/store/index.js'
import * as loadingAnimation from '../../../shared/components/loading.json'
import { EventBus } from '../../../js/plugins/event-bus'

export default defineComponent({
  name: 'ModalPostPack',
  components: {},

  setup() {
    const store = useStore()

    const loadingAnimationOptions = { animationData: loadingAnimation.default }
    const thinking = ref(false)

    // @TODO hook this up to default the the logged in user's email, but allow it to be changed
    const invoiceEmail = ref('')

    const organisation = computed(() => {
      return store.getters['shared/getSettings']
    })

    const canSubmit = computed(() => {
      return packSize.value !== null && invoiceEmail.value.length >= 6
    })

    const packSize = ref(null)

    const submit = async () => {
      thinking.value = true
      const payload = {
        organisation: organisation.value.profile_title,
        email: invoiceEmail.value,
        pack: {
          cost: Number(packSize.value) * 99 * 1.15,
          posts: packSize.value,
        },
      }
      const response = await store.dispatch(
        'expo/dispatchSendEmailPostPack',
        payload,
      )
      thinking.value = false
      if (response) {
        invoiceEmail.value = ''
        EventBus.$emit('showModal', false)
      }
    }

    onMounted(() => {
      invoiceEmail.value = store.getters['shared/getUser'].email
    })

    return {
      loadingAnimationOptions,
      thinking,
      organisation,
      invoiceEmail,
      packSize,
      canSubmit,
      submit,
    }
  },
})
</script>
